import React from 'react';
import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../../style/prediction.module.scss";
import {PredictionOddCell} from "./prediction.odd-cell";
import {PredictionOddsCells} from "./prediction.odds-cells";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {APP} from "../../../../app/consts";
import {PartialGameViewModel} from "../../../../../domain/partial-game/models/partial-game-view-model";

export const PredictionOdds = observer(({
                                          controller,
                                          odds,
                                          isFirst,
                                          isLast,
                                          isSelected,
                                          bookmaker,
                                          rateOptionsLength,
                                          betsImpressionParams,
                                          isSingleOdd
                                        }) => {
    const {state} = controller;
    const {
      gameId,
      currentLinkModel,
      isContextualMode,
      isContextualUsed,
      enableVoting,
      isBettingPage,
      bookieLinkContext,
      hasOdds,
      screen
    } = state;

    const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
      bookieId: odds?.bookmaker?.id,
      bookieName: odds?.bookmaker?.name,
      urlLink: odds?.link,
      type: odds.lineTypeId,
      currentLinkModelName: currentLinkModel?.name,
      entityType: APP.ANALYTICS.ENTITY_DISPLAY_TYPES[PartialGameViewModel.name],
      entityId: gameId,
      widget: APP.GOOGLE_ANALYTICS.SOURCES.prediction,
      source: APP.ANALYTICS.SOURCES.predictions,
      isContextual: isContextualMode,
      contextualUsed: isContextualUsed,
      enableVote: enableVoting,
      isApostas: isBettingPage,
      bookieLinkContext,
      hasOdds,
      screen,
      buttonType: APP.ANALYTICS.BUTTON_TYPES_MAPPER[rateOptionsLength][odds.num],
      impressionType: APP.ANALYTICS.BETS_IMPRESSION_TYPES.odds,
      actualBetOdd: odds.currentRate
    });

    const buttonProps = {
      className: classNames(styles.odds)
    }

    const oddCellProps = {
      controller,
      odds,
      isFirst,
      isLast,
      isSelected,
      onClick: () => onBookieClick(),
      bookmaker,
      bookieHrefModel,
      betsImpressionParams
    }

    const oddsCellsProps = {
      odds,
      isFirst,
      isLast,
      isSelected,
      onClick: () => onBookieClick(),
      bookmaker,
      controller,
      bookieHrefModel,
      betsImpressionParams
    }

    return (
      <div {...buttonProps}>
        {
          isSingleOdd ? <PredictionOddCell {...oddCellProps}/> : <PredictionOddsCells {...oddsCellsProps}/>
        }
      </div>
    )
  }
);
